import { TrainStopRow } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/TrainStop/TrainStopRow";
import { isStopWithNoPassing } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/TrainStop/utils";
import { FillrateResponse } from "features/CenterContent/VehicleDetails/TrainDetails/TrainRoute/types";
import { TrainRoute } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";
import { FC, useRef } from "react";
import { Semantics } from "shared/components/drops/DropsBadge";

type TrainStopContentProps = {
  data: TrainRoute;
  fillRate: FillrateResponse | undefined;
};
export const TrainStopContent: FC<TrainStopContentProps> = ({
  data,
  fillRate,
}) => {
  const lastArrivedIndex = data.stops.map((s) => s.isArrived).lastIndexOf(true);
  const prevSemanticsRef = useRef<Semantics | undefined>(undefined);

  return data.stops.map((stop, index, array) => {
    const isLastStop = index + 1 === array.length;
    const isCurrentStop = index === lastArrivedIndex;
    const isVisited = index <= lastArrivedIndex;
    const isNoPassing = isStopWithNoPassing(index, lastArrivedIndex, stop);
    const trainStopRow = (
      <TrainStopRow
        key={stop.stopId}
        prevSemantics={prevSemanticsRef}
        stop={stop}
        isLastStop={isLastStop}
        isCurrentStop={isCurrentStop}
        isVisited={isVisited}
        isNoPassing={isNoPassing}
        fillrate={fillRate?.fillrate ?? null}
      />
    );
    return trainStopRow;
  });
};
